export enum VisitType {
    VIDEO_CALL,
    PHONE_CALL,
}
